import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlError extends BaseControl {
    private _message: HTMLElement;
    private _element: HTMLElement;

    constructor(pano: Pano) {
        super(pano);

        this._element = document.createElement("div");
        this._element.classList.add("error-container");
        this._element.innerHTML = `
            <div class="box">
                <div class="icon fas fa-triangle-exclamation"></div>
                <div class="message"></div>
            </div>
        `;
        this.pano.addControl(this._element, ControlPosition.OVERLAY);
        this._message = this._element.querySelector(".message");

        this._element.addEventListener("click", () => this.hide());
        this.pano.video.addEventListener("error", (e: ErrorEvent) => this.show(e.error));
        this.pano.onChangeVideo.add(() => this.hide());
        this.pano.onError.add((err) => {
            this.show(err);
        });
    }

    private show(err: Error = null): void {
        var message = err ? err.message : "Leider ist ein Fehler aufgetreten";
        this._message.textContent = message;
        this.pano.element.classList.add("error");
        this._element.classList.add("active");
    }

    private hide(): void {
        this.pano.element.classList.remove("error");
        this._element.classList.remove("active");
    }
}